import React from "react";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { filterByName } from "../utils";

export class LocationInput extends React.PureComponent {
  render() {
    const {
      label = "Location",
      source = "location",
      reference = "locations",
      filterToQuery = filterByName,
      perPage = 100,
      sort = { field: "name", order: "ASC" },
      ...rest
    } = this.props;
    return (
      <ReferenceInput
        label={label}
        source={source}
        reference={reference}
        // filterToQuery={filterToQuery}
        perPage={perPage}
        sort={sort}
        {...rest}
      >
        <AutocompleteInput filterToQuery={filterToQuery} optionText="name" />
      </ReferenceInput>
    );
  }
}
